import { USER_MODES } from 'constants.js';
import { store } from 'store';
import { getUserIsKids } from './User';

const getFirstNode = (claroAdEnable = false) => {
  const claroLiteConfig =
    JSON.parse(store.getState().metadata?.cv_advertising_config || '{}') || {};

  const { region } =
    JSON.parse(localStorage.getItem('startHeaderInfoResponse'))?.response || {};

  const regionEnable = claroLiteConfig?.[region]?.enable;
  const defaultEnable = claroLiteConfig?.default?.enable;

  const claroLiteConfigEnabled =
    claroAdEnable || regionEnable || defaultEnable || false;

  const nodes = store.getState().cvNavData?.navData?.main;
  const userType = store.getState().user?.userTypeLite;

  const getFallBackNode = () => {
    if (claroLiteConfigEnabled) return 'homeuser_lite';

    if (getUserIsKids()) return 'homeuser_kids';

    return 'homeuser';
  };

  let fallBackNode = getFallBackNode();

  switch (userType) {
    case USER_MODES.nav_freemium_not_logged:
      if (claroLiteConfigEnabled) {
        fallBackNode = 'homeuser_lite';
      }
      break;
    case USER_MODES.nav_freemium_logged:
      if (claroLiteConfigEnabled) {
        fallBackNode = 'homeuser_lite';
      }
      break;
    case USER_MODES.nav_premium:
      if (getUserIsKids()) {
        fallBackNode = 'homeuser_kids';
      }
      fallBackNode = 'homeuser';
      break;

    default:
      break;
  }

  return nodes?.[0]?.code || fallBackNode;
};

export default getFirstNode;
